import { getQueryVariable } from '@/components/util';

export const getUrlVariables = (url: any, iframeUrl: any) => {
  const id = getQueryVariable(url, 'm') as string;
  const iframeId = getQueryVariable(iframeUrl, 'm') as string;
  const start = getQueryVariable(url, 'start');

  // normal
  const sr = getQueryVariable(url, 'sr'); // rotation
  const ss = getQueryVariable(url, 'ss'); // sweep

  // floor plan or dollhouse
  const sm = getQueryVariable(url, 'sm'); // mode
  const sz = getQueryVariable(url, 'sz'); // zoom
  const sp = getQueryVariable(url, 'sp'); // position

  const linkData = start ? JSON.parse(String(start)) : false;
  const rand = Math.floor(Math.random() * 1000000 + 1);
  let linkDataShort: any = sr && ss ? { sr: sr.split(','), ss: parseInt(String(ss), 10) } : false;
  if (!linkDataShort)
    linkDataShort =
      sp && sr && sm
        ? {
            sm: parseInt(sm, 10),
            sr: sr.split(','),
            sp: sp.split(','),
            sz: sz ? parseFloat(String(sz)) : null,
          }
        : false;

  return {
    id,
    iframeId,
    linkData,
    rand,
    linkDataShort,
  };
};
